export { copyToClipboard as default };
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';

async function copyToClipboard(clipboard) {
  try {
    await navigator.clipboard.writeText(clipboard);
    this.$toast({
      component: core_components_toastification_ToastificationContent_vue,
      props: {
        text: "Copied to clipboard",
        icon: "EditIcon",
        variant: "success"
      }
    });
  } catch (e) {
    this.$toast({
      component: core_components_toastification_ToastificationContent_vue,
      props: {
        text: "Sorry, failed to copy, use it manually, please ",
        icon: "EditIcon",
        variant: "warning"
      }
    });
  }
}

